import Repo from "../Utility/Repo";
import { useEffect, useState, useContext } from "react";
import { TokenContext } from "./TokenContext"

function ValidISEE() {
    const apiToken = useContext(TokenContext);
    const [isValidISEE, setIsValidISEE] = useState("d-none");
    const [msg, setMsg] = useState("");
 



    useEffect(() => {
      getUserAPI();
      return () => {
        setIsValidISEE(""); // This worked for me
      };
  }, []);



    const getUserAPI = () => {
      
        Repo.getUser(apiToken)
          .then((response) => {
           
         const lastISEE = response.data.isees.sort((a, b) => a.date - b.date).shift();
       //  console.log(response.data.isees.sort((a, b) => a.date - b.date));
    
            if (lastISEE && lastISEE.state == "VALIDATED" ){
              setIsValidISEE("d-none");
            }else  if (lastISEE && lastISEE.state == "LOADED" ){
              setIsValidISEE("");
              setMsg("l'ISEE caricato non è ancora stato validato.  Per proseguire con le iscrizioni  ai bandi è necessario attendere la sua validazione!");
            }else  if (lastISEE && lastISEE.state == "REFUSED" ){
              setIsValidISEE("");
              setMsg(" ISEE caricato è stato rifiutato.  Per proseguire con le iscrizioni  ai bandi è necessario caricare un nuovo ISEE in corso di validità dalla sezione <b>Carica nuovo ISEE</b>");
            }
            else{
              setIsValidISEE("");
              setMsg("non risulta caricato nessu ISEE. Per proseguire con le iscrizioni ai bandi è necessario caricare un ISEE in corso di validità dalla sezione <b>Carica nuovo ISEE</b>");
            }
    
            
          })
          .catch((error) => {
            console.log(error);
         
          });
      };
     

    return (
<div className={`alert alert-danger ${isValidISEE}`} role="alert">
<h4 className="alert-heading">Attenzione!</h4>
 <div dangerouslySetInnerHTML={{ __html: msg }} />
</div>
    );
  }

export default ValidISEE;